module.exports = __webpack_public_path__ + "img/check_two.b82a834e.svg";